import React from 'react';
import { LogoFull } from './Logo';

// ═══ 이용약관 / 개인정보처리방침 ═══
//
// ⚠️ 공개 전 반드시 채워야 하는 항목 (현재 '○○○' 로 비어 있음):
//    ① 회사 상호·대표자·사업자등록번호·주소  ② 개인정보 보호책임자 성명·직책·연락처
//    ③ 시행일(SINCE)  ④ 세무·통관 대행 수탁자 상호(이용자별로 다르면 '이용자가 지정한 자' 유지)
// ⚠️ 본 문안은 2026-07-25 기준 **실제 시스템 처리 실태**(코드 기준)에 맞춰 작성됨.
//    처리 항목·위탁처·보관기간이 바뀌면 이 문서도 함께 고쳐야 함(방침 허위기재는 법 위반).
//    변경 이력: 2026-07-25 전면 개정 — 구 문안의 사실오류 정정
//      · "주민등록번호는 서류 생성 후 DB에서 즉시 삭제" → 실제로는 AES 암호화하여 계속 보관
//      · "제3자에게 제공하지 않음" → 이용자 지시에 따라 세무대리인 등에게 전송함
//      · 처리위탁(Claude/CLOVA/GCP 등)·국외이전 조항 자체가 없었음 → 신설

var SINCE = '시행일: 2026년 ○월 ○일 | 최종 개정: 2026년 7월 25일';

var pageStyle = { maxWidth: 720, margin: '0 auto', padding: '40px 24px', fontFamily: "'Pretendard',sans-serif", color: '#333', lineHeight: 1.8, fontSize: 14 };
var h2Style = { fontSize: 17, fontWeight: 700, color: '#1B3A5C', margin: '28px 0 10px', borderLeft: '4px solid #1B3A5C', paddingLeft: 12 };
var ulStyle = { margin: '6px 0 12px', paddingLeft: 20 };
var noteStyle = { background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '12px 16px', margin: '12px 0', fontSize: 13, color: '#92400e' };
var boxStyle = { background: '#f8fafc', borderRadius: 8, padding: 16, margin: '10px 0' };
var tdStyle = { border: '1px solid #e5e7eb', padding: '8px 12px', verticalAlign: 'top' };
var thStyle = { border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'left', fontWeight: 600 };

// 표 헬퍼 — cols: 헤더 배열, rows: 셀 배열의 배열
var table = function (cols, rows) {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', margin: '10px 0 16px', fontSize: 13 }}>
      <thead><tr style={{ background: '#f8fafc' }}>
        {cols.map(function (c, i) { return <th key={i} style={thStyle}>{c}</th>; })}
      </tr></thead>
      <tbody>
        {rows.map(function (r, i) {
          return <tr key={i}>{r.map(function (cell, j) { return <td key={j} style={tdStyle}>{cell}</td>; })}</tr>;
        })}
      </tbody>
    </table>
  );
};

var header = function(title, sub) {
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: 32 }}><a href="/" style={{ textDecoration: 'none' }}><LogoFull iconSize={36} fontSize={24} /></a></div>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0f172a', textAlign: 'center', marginBottom: 8 }}>{title}</h1>
      <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, marginBottom: 32 }}>{sub}</p>
    </div>
  );
};
var footer = function() {
  return (
    <div style={{ marginTop: 48, paddingTop: 20, borderTop: '1px solid #e5e7eb', textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>
      <p>AUTODEX. All rights reserved.</p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 8 }}>
        <a href="/" style={{ color: '#3b82f6', textDecoration: 'none', fontSize: 13 }}>홈으로</a>
        <a href="/terms" style={{ color: '#64748b', textDecoration: 'none', fontSize: 13 }}>이용약관</a>
        <a href="/privacy" style={{ color: '#64748b', textDecoration: 'none', fontSize: 13 }}>개인정보처리방침</a>
      </div>
    </div>
  );
};

function Terms() {
  return (
    <div style={pageStyle}>
      {header('이용약관', SINCE)}

      <h2 style={h2Style}>제1조 (목적)</h2>
      <p>이 약관은 ○○○(이하 "회사")가 제공하는 AI 기반 중고차 수출 업무 관리 서비스 AUTODEX(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>

      <h2 style={h2Style}>제2조 (용어의 정의)</h2>
      <ul style={ulStyle}>
        <li><strong>"서비스"</strong>란 차량 등록, AI 문서 인식(OCR), 서류 자동생성(매매계약서·말소신청서·인보이스 등), 말소·통관 진행 관리, 세무 처리, 장부 관리, 차량 평가, 경매 등 중고차 수출 업무 자동화 기능 일체를 말합니다.</li>
        <li><strong>"이용자"</strong>란 이 약관에 동의하고 회사의 승인을 받아 서비스를 이용하는 사업자(법인 또는 개인사업자) 및 그 소속 이용 계정을 말합니다.</li>
        <li><strong>"차량정보주체"</strong>란 이용자가 서비스에 입력·업로드하는 차량의 소유자(명의자) 등 <strong>이용자가 아닌 제3자로서 개인정보가 처리되는 자</strong>를 말합니다.</li>
        <li><strong>"이용자 데이터"</strong>란 이용자가 서비스에 입력·업로드하거나 서비스 이용 과정에서 생성된 차량·거래·서류 데이터를 말합니다.</li>
        <li><strong>"계정"</strong>이란 이용자가 서비스에 접속하기 위해 부여받은 아이디와 비밀번호의 조합을 말합니다.</li>
      </ul>

      <h2 style={h2Style}>제3조 (약관의 효력 및 변경)</h2>
      <p>1. 이 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</p>
      <p>2. 회사는 관련 법령을 위반하지 않는 범위에서 약관을 변경할 수 있으며, 변경 약관은 시행일 7일 전(이용자에게 불리한 변경은 30일 전)에 공지합니다.</p>
      <p>3. 이용자가 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 해지할 수 있습니다. 공지된 기간 내에 거부 의사를 표시하지 않으면 변경에 동의한 것으로 봅니다.</p>

      <h2 style={h2Style}>제4조 (서비스 가입 및 승인)</h2>
      <p>1. 이용자는 회사가 정한 가입 절차에 따라 필요한 정보를 제공하고 서비스에 가입합니다.</p>
      <p>2. 회사는 가입 신청을 검토한 후 승인 또는 거절할 수 있으며, 거절 시 사유를 안내합니다.</p>
      <p>3. 사업자 단위로 계정을 부여하며, 소속 직원 계정은 이용자의 관리 책임 하에 발급·회수됩니다.</p>
      <p>4. 허위 정보로 가입하거나 타인의 정보를 도용한 경우 서비스 이용이 즉시 제한될 수 있습니다.</p>

      <h2 style={h2Style}>제5조 (서비스 이용 및 요금)</h2>
      <p><strong>이용 요금:</strong> 서비스는 현재 무료로 제공되며, AI 문서 인식 횟수 등 이용 한도가 적용될 수 있습니다.</p>
      <p><strong>유료 서비스 도입:</strong> 회사는 향후 일부 기능에 대해 유료 서비스 또는 수수료를 도입할 수 있으며, 이 경우 제3조에 따라 사전에 공지합니다. 무료 이용 중 등록한 데이터는 유료 서비스 도입 이후에도 유지됩니다.</p>
      <p><strong>서비스 시간:</strong> 연중무휴 24시간 제공을 원칙으로 하되, 정기 점검 시 사전 공지합니다.</p>

      <h2 style={h2Style}>제6조 (이용자의 의무)</h2>
      <p>이용자는 다음 행위를 해서는 안 됩니다:</p>
      <ul style={ulStyle}>
        <li>타인의 계정을 무단으로 사용하거나 개인정보를 부정하게 수집하는 행위</li>
        <li>서비스를 통해 취득한 정보(차량정보주체의 개인정보 포함)를 업무 목적 외로 이용하거나 무단으로 제3자에게 제공하는 행위</li>
        <li>자동화된 수단(봇, 크롤러 등)으로 서비스에 접근하거나 데이터를 수집하는 행위</li>
        <li>서비스의 안정적 운영을 방해하거나 시스템에 과도한 부하를 주는 행위</li>
        <li>서비스를 이용하여 법령에 위반되는 행위를 하는 것</li>
        <li>회사의 지적재산권을 침해하는 행위</li>
      </ul>

      <h2 style={h2Style}>제7조 (차량정보주체 개인정보에 관한 이용자의 책임 및 처리위탁)</h2>
      <div style={noteStyle}>
        이 조는 서비스의 성격상 가장 중요한 조항입니다. 이용자가 업로드하는 차량 소유자의 개인정보(성명·주소·<strong>주민등록번호</strong> 등)에 대해서는 <strong>이용자가 개인정보처리자</strong>이고, <strong>회사는 그 처리를 위탁받은 수탁자</strong>의 지위에 있습니다.
      </div>
      <p>1. 이용자는 차량정보주체의 개인정보를 <strong>적법하게 수집</strong>하고, 서비스에 입력·업로드하여 처리하는 데 필요한 <strong>동의 또는 법령상 근거를 확보</strong>할 책임을 부담합니다.</p>
      <p>2. 이용자는 서비스 이용을 위해 필요한 최소한의 개인정보만 입력하여야 하며, 업무와 무관한 개인정보를 업로드해서는 안 됩니다.</p>
      <p>3. 회사는 이용자의 지시와 이 약관·개인정보처리방침이 정한 범위 내에서만 해당 개인정보를 처리하며, 「개인정보 보호법」 제26조에 따른 수탁자의 의무를 준수합니다. 회사는 위탁받은 개인정보를 <strong>자사의 목적으로 이용하지 않습니다.</strong></p>
      <p>4. 회사는 업무 수행에 필요한 범위에서 제3자에게 재위탁할 수 있으며, 재위탁 현황은 개인정보처리방침에 공개합니다.</p>
      <p>5. 이용자가 제1항의 의무를 위반하여 발생한 분쟁·손해에 대해서는 이용자가 책임을 부담합니다.</p>

      <h2 style={h2Style}>제8조 (이용자 데이터의 귀속 및 반출)</h2>
      <p>1. 이용자 데이터에 관한 권리는 이용자에게 귀속합니다. 회사는 서비스 제공·유지·장애 대응 및 법령 준수에 필요한 범위에서만 이를 처리합니다.</p>
      <p>2. 회사는 이용자 데이터를 <strong>이용자의 동의 없이 다른 이용자에게 제공하거나 광고·마케팅 목적으로 이용하지 않습니다.</strong></p>
      <p>3. 이용자는 이용 기간 중 서비스가 제공하는 기능(엑셀·PDF·ZIP 내려받기 등)을 통해 자신의 데이터를 반출할 수 있습니다.</p>
      <p>4. 회사는 서비스 개선을 위해 개인을 식별할 수 없도록 <strong>가명·익명 처리된 통계</strong>를 이용할 수 있습니다.</p>

      <h2 style={h2Style}>제9조 (서비스 중단 및 변경)</h2>
      <p>1. 회사는 시스템 점검, 장비 교체, 천재지변 등 불가피한 사유가 있는 경우 서비스를 일시 중단할 수 있으며, 가능한 범위에서 사전 공지합니다.</p>
      <p>2. 회사는 서비스의 기능을 추가·변경·중단할 수 있으며, 중요한 변경은 30일 전에 공지합니다.</p>

      <h2 style={h2Style}>제10조 (계약 해지 및 데이터 처리)</h2>
      <p>1. 이용자는 언제든지 서비스 해지(탈퇴)를 요청할 수 있으며, 회사는 요청 접수 후 지체 없이 처리합니다.</p>
      <p>2. 해지 시 이용자 데이터는 개인정보처리방침이 정한 절차에 따라 파기합니다. 다만 <strong>관계 법령(세법·전자상거래법 등)에 따라 보존 의무가 있는 정보는 해당 기간 동안 분리 보관</strong>합니다.</p>
      <p>3. 이용자는 해지 전에 필요한 데이터를 직접 반출하여야 하며, 해지 후 데이터 복구 요청에 회사가 응하지 못할 수 있습니다.</p>
      <p>4. 회사는 이용자가 이 약관을 위반한 경우 사전 통지 후 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.</p>

      <h2 style={h2Style}>제11조 (AI 자동 인식 결과에 관한 고지)</h2>
      <p>1. 서비스는 자동차등록증·말소증·수출신고필증 등에서 정보를 자동으로 인식(OCR)하여 입력을 보조합니다. <strong>인식 결과에는 오류가 있을 수 있습니다.</strong></p>
      <p>2. 이용자는 자동 인식된 값(차량번호·차대번호·금액·일자 등)을 <strong>제출·신고 전에 원본 서류와 대조하여 확인할 책임</strong>이 있습니다.</p>
      <p>3. 서비스가 생성한 서류·신고자료는 업무 보조 자료이며, 관계 기관에 대한 최종 제출 책임은 이용자에게 있습니다.</p>

      <h2 style={h2Style}>제12조 (면책)</h2>
      <p>1. 회사는 이용자가 서비스를 통해 생성한 서류의 법적 효력이나 자동 인식 결과의 정확성을 보증하지 않으며, 이용자는 제11조에 따라 이를 확인할 책임이 있습니다.</p>
      <p>2. 회사는 천재지변, 전쟁, 정전, 통신사 장애, 해킹·디도스 등 불가항력으로 인한 서비스 중단이나 데이터 손실에 대해 책임을 지지 않습니다.</p>
      <p>3. 이용자의 귀책사유(계정정보 관리 소홀, 잘못된 입력, 법령 위반 등)로 인한 손해에 대해 회사는 책임을 지지 않습니다.</p>
      <p>4. 회사의 고의 또는 중과실이 없는 한, 회사의 손해배상 책임은 <strong>손해 발생 직전 3개월간 이용자가 회사에 지급한 서비스 요금</strong>을 한도로 합니다.</p>

      <h2 style={h2Style}>제13조 (지적재산권)</h2>
      <p>서비스에 포함된 소프트웨어, 디자인, 로고, 문서 양식 및 관련 지적재산권은 회사 또는 정당한 권리자에게 귀속됩니다. 이용자는 서비스 이용 목적 범위에서만 이를 이용할 수 있으며, 이용자 데이터에 대한 권리는 제8조에 따라 이용자에게 귀속합니다.</p>

      <h2 style={h2Style}>제14조 (준거법 및 분쟁 해결)</h2>
      <p>1. 이 약관은 대한민국 법을 준거법으로 합니다.</p>
      <p>2. 서비스 이용과 관련하여 분쟁이 발생한 경우 회사와 이용자는 성실히 협의하여 해결하며, 협의가 이루어지지 않을 경우 <strong>민사소송법상 관할 법원</strong>에 소를 제기할 수 있습니다.</p>

      {footer()}
    </div>
  );
}

function Privacy() {
  return (
    <div style={pageStyle}>
      {header('개인정보처리방침', SINCE)}

      <p>○○○(이하 "회사")는 「개인정보 보호법」 등 관계 법령을 준수하며, 정보주체의 개인정보를 보호하기 위해 다음과 같이 개인정보처리방침을 수립·공개합니다.</p>

      <h2 style={h2Style}>제1조 (회사의 지위 — 반드시 확인)</h2>
      <div style={noteStyle}>
        AUTODEX는 성격이 다른 두 종류의 개인정보를 다룹니다.
        <ul style={{ margin: '8px 0 0', paddingLeft: 20 }}>
          <li><strong>회원(이용 사업자·소속 직원)의 개인정보</strong> — 회사가 <strong>개인정보처리자</strong>로서 직접 처리합니다.</li>
          <li><strong>차량 소유자(명의자) 등 제3자의 개인정보</strong> — 이용자(수출업체 등)가 처리자이고, 회사는 이용자로부터 <strong>처리를 위탁받은 수탁자</strong>입니다. 회사는 이를 <strong>이용자의 지시 범위에서만</strong> 처리하며 자사 목적으로 이용하지 않습니다.</li>
        </ul>
      </div>

      <h2 style={h2Style}>제2조 (처리하는 개인정보 항목)</h2>
      {table(['구분', '처리 항목', '수집 방법'], [
        ['회원 — 필수', '아이디, 비밀번호(해시), 업체명, 대표자명, 사업자등록번호', '회원가입'],
        ['회원 — 선택', '휴대전화번호, 이메일, 사업자등록증 사본, 담당자명, 인감·서명 이미지', '회원가입 · 설정'],
        [<span><strong>차량정보주체</strong><br />(위탁 처리)</span>,
          <span>성명, 주소, 연락처, <strong>주민등록번호·외국인등록번호·법인등록번호</strong>, 서명 이미지, 신분증·자동차등록증·말소증 등 <strong>서류 이미지</strong>, 계좌·입금 증빙</span>,
          '이용자의 직접 입력 · 서류 업로드 및 자동 인식(OCR)'],
        ['거래 상대', '매수인(바이어) 성명·연락처·국가, 거래처 담당자 정보', '이용자 입력'],
        ['자동 수집', '접속 IP, 접속 일시, 브라우저·기기 정보, 서비스 이용 기록, 개인정보 열람 기록', '서비스 이용 시 자동 생성'],
      ])}
      <p style={{ fontSize: 13, color: '#64748b' }}>※ 회사는 사상·신념, 노동조합 가입, 정치적 견해, 건강·성생활 등 <strong>민감정보를 수집하지 않습니다.</strong> 서류 이미지에 불필요한 정보가 포함되지 않도록 하는 것은 이용자의 책임입니다(이용약관 제7조).</p>

      <h2 style={h2Style}>제3조 (개인정보의 처리 목적)</h2>
      <ul style={ulStyle}>
        <li>회원 가입 의사 확인, 이용자 식별·인증, 계정 및 권한 관리</li>
        <li>서비스 제공 — 차량 등록, 서류 자동생성(매매계약서·말소신청서·인보이스 등), 말소·통관 진행 관리</li>
        <li>수출 관련 신고·신청 업무 지원(자동차 말소등록, 수출신고, 부가가치세 환급 신고자료 작성 등)</li>
        <li>서류의 자동 인식(OCR) 및 차량 데이터 추출</li>
        <li>요금 정산, 세금계산서 수취 및 회계·세무 처리</li>
        <li>공지 전달, 문의·불만 처리, 분쟁 대응</li>
        <li>부정 이용 방지, 접속 기록 보관 등 서비스 안정성 확보</li>
      </ul>

      <h2 style={h2Style}>제4조 (고유식별정보의 처리)</h2>
      <div style={noteStyle}>
        회사는 차량 소유자의 <strong>주민등록번호 등 고유식별정보를 실제로 저장·보관</strong>합니다. 다음의 법령상 근거에 따라 처리하며, 목적 달성 시 지체 없이 파기합니다.
      </div>
      <p>1. 처리 근거 — 「자동차등록령」·「자동차관리법」에 따른 <strong>이전·말소등록 신청 서류 작성</strong>, 「부가가치세법」·「조세특례제한법」에 따른 <strong>의제매입세액 공제 신고자료 작성</strong> 등 법령에서 구체적으로 요구하는 사무의 수행.</p>
      <p>2. 보호 조치 — <strong>AES 암호화하여 저장</strong>하고, 화면·목록·로그·API 응답에서는 항상 <strong>마스킹(예: 890801-1******)</strong> 하여 표시합니다. 복호화된 원본값은 관계 기관 제출용 서류·신고자료를 생성하는 경우에 한하여 사용됩니다.</p>
      <p>3. 접근 통제 — 소속 업체 범위로 접근을 제한하며, 고유식별정보 열람 시 <strong>열람 기록을 별도로 보관</strong>합니다.</p>

      <h2 style={h2Style}>제5조 (개인정보의 보유·이용 기간)</h2>
      <p>1. 회원 정보는 <strong>회원 탈퇴 시까지</strong> 보유하며, 탈퇴 요청 시 지체 없이 파기합니다.</p>
      <p>2. 차량정보주체의 개인정보는 <strong>위탁 목적(해당 차량의 말소·수출·정산·신고 업무) 달성 시</strong> 또는 이용자의 삭제 지시 시 파기합니다.</p>
      <p>3. 다만 다음의 경우 해당 기간 동안 보존합니다.</p>
      {table(['근거 법령', '대상', '기간'], [
        ['부가가치세법·법인세법·국세기본법', '세금계산서, 거래·신고 관련 증빙', '5년'],
        ['전자상거래 등에서의 소비자보호에 관한 법률', '계약·청약철회, 대금결제 기록', '5년'],
        ['전자상거래 등에서의 소비자보호에 관한 법률', '소비자 불만·분쟁처리 기록', '3년'],
        ['통신비밀보호법', '서비스 접속 기록(로그인 기록)', '3개월'],
      ])}
      <div style={noteStyle}>
        <strong>백업본 관련 고지:</strong> 회사는 데이터 유실에 대비해 정기 백업을 수행하며, 백업본은 별도 보관소에 보존됩니다. 이에 따라 <strong>운영 데이터에서 삭제된 정보가 백업본에는 일정 기간 남아 있을 수 있습니다.</strong> 백업본은 복구 목적 외로 이용하지 않으며, 보존 기간이 지나면 순차 삭제됩니다.
      </div>

      <h2 style={h2Style}>제6조 (개인정보의 제3자 제공)</h2>
      <p>1. 회사는 정보주체의 개인정보를 제3조의 목적 범위를 초과하여 이용하거나 제3자에게 제공하지 않습니다.</p>
      <p>2. 다만 다음의 경우는 예외로 합니다.</p>
      <ul style={ulStyle}>
        <li>정보주체(또는 위탁자인 이용자)로부터 별도의 동의를 받은 경우</li>
        <li>법령에 특별한 규정이 있거나, 수사기관이 법령에 정한 절차와 방법에 따라 요구한 경우</li>
      </ul>
      <div style={noteStyle}>
        <strong>이용자 지시에 따른 전송:</strong> 서비스에는 이용자가 <strong>수신자를 직접 지정하여</strong> 세무 자료(주민등록번호가 포함된 신고자료·증빙 포함)를 세무대리인에게 이메일로 보내거나, 인보이스를 관세사에게 전송하는 기능이 있습니다. 이는 <strong>이용자 본인의 업무 처리 행위</strong>이며, 회사는 이용자의 지시를 이행하는 전송 수단을 제공합니다. 해당 수신자에 대한 제공의 적법성 확보와 자료 관리 책임은 이용자에게 있습니다.
      </div>

      <h2 style={h2Style}>제7조 (개인정보 처리업무의 위탁)</h2>
      <p>회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리업무를 위탁하고 있습니다. 위탁계약 시 개인정보의 안전한 관리에 관한 사항을 계약서에 반영하고 있습니다.</p>
      {table(['수탁자', '위탁 업무 내용'], [
        ['Google Cloud Platform (Google LLC)', '서버·데이터베이스·파일 저장소 운영 (국내 리전 저장)'],
        ['Anthropic, PBC', '서류 이미지·텍스트의 AI 자동 인식(OCR) 및 항목 구조화, 문의 응답 보조'],
        ['OpenAI, L.L.C.', '서류 이미지 자동 인식 보조 (선택 기능 사용 시)'],
        ['네이버클라우드(주)', 'CLOVA OCR — 서류 이미지의 텍스트 추출'],
        ['팝빌 (전자세금계산서 연동 서비스 제공자 ○○○)', '매입 세금계산서 수취·조회'],
        ['메일 서비스 제공자 (네이버웍스 등 ○○○)', '알림 및 세무·통관 자료 전송용 이메일 발송'],
        ['Google LLC (Firebase) · Expo', '모바일 앱 푸시 알림 발송'],
        ['Telegram (Telegram FZ-LLC 등)', '운영자 대상 내부 업무 알림 발송 (업체명·담당자명·차량번호 등 포함)'],
      ])}
      <p style={{ fontSize: 13, color: '#64748b' }}>※ 위탁 업무 내용이나 수탁자가 변경될 경우 이 방침을 통해 공개합니다.</p>

      <h2 style={h2Style}>제8조 (개인정보의 국외 이전)</h2>
      <p>회사는 서비스 제공을 위해 다음과 같이 개인정보를 국외로 이전(처리위탁)하고 있습니다.</p>
      {table(['이전받는 자 / 국가', '이전 항목', '이전 목적 · 시점 · 방법', '보유 기간'], [
        ['Anthropic, PBC (미국)', '업로드된 서류 이미지 및 그 텍스트(성명·주소·차량정보 등 포함될 수 있음)', 'AI 자동 인식·구조화 / 이용자가 서류를 업로드하거나 인식을 요청하는 시점 / HTTPS 전송', '처리 후 즉시 파기 (모델 학습에 이용되지 않음)'],
        ['OpenAI, L.L.C. (미국)', '업로드된 서류 이미지 (선택 기능 사용 시)', '서류 자동 인식 보조 / 이용자가 해당 엔진을 선택한 시점 / HTTPS 전송', '처리 후 즉시 파기'],
        ['Telegram (아랍에미리트 등 국외)', '운영 알림에 포함되는 업체명·담당자명·차량번호', '서비스 운영자 대상 내부 알림 / 해당 업무 이벤트 발생 시 / HTTPS 전송', '알림 채널 보존 정책에 따름'],
      ])}
      <div style={noteStyle}>
        정보주체는 개인정보의 국외 이전을 거부할 수 있습니다. 다만 자동 인식(OCR) 기능은 이용이 제한되며, 이 경우 <strong>수기 입력으로 서비스를 이용</strong>할 수 있습니다. 거부 의사는 제12조의 연락처로 알려 주시기 바랍니다.
      </div>
      <p style={{ fontSize: 13, color: '#64748b' }}>※ 서버·저장소(Google Cloud)는 <strong>국내 리전</strong>에 위치하여 개인정보가 국외에 저장되지 않습니다.</p>

      <h2 style={h2Style}>제9조 (개인정보의 파기 절차 및 방법)</h2>
      <p>1. 회사는 보유 기간이 경과하거나 처리 목적이 달성된 경우 지체 없이(원칙적으로 5일 이내) 해당 개인정보를 파기합니다.</p>
      <p>2. 법령에 따라 보존해야 하는 정보는 다른 개인정보와 <strong>분리하여 별도 보관</strong>한 후 기간 경과 시 파기합니다.</p>
      <p>3. 파기 방법 — 전자적 파일 형태는 <strong>복구할 수 없는 방법으로 영구 삭제</strong>하고, 출력물은 분쇄하거나 소각합니다.</p>
      <p>4. 서비스는 일부 서류(예: 말소 완료 후 신분증 사본)에 대해 <strong>목적 달성 후 자동 삭제</strong>가 동작합니다.</p>

      <h2 style={h2Style}>제10조 (정보주체와 법정대리인의 권리·의무 및 행사 방법)</h2>
      <p>1. 정보주체는 회사에 대해 언제든지 다음 권리를 행사할 수 있습니다.</p>
      <ul style={ulStyle}>
        <li>개인정보 <strong>열람</strong> 요구</li>
        <li>오류 등이 있을 경우 <strong>정정</strong> 요구</li>
        <li><strong>삭제</strong> 요구 (법령상 보존 의무가 있는 경우 제외)</li>
        <li><strong>처리정지</strong> 요구 및 동의 <strong>철회</strong></li>
      </ul>
      <p>2. 권리 행사는 서비스 내 설정 메뉴, 이메일(support@autodex.kr) 또는 서면으로 할 수 있으며, 회사는 지체 없이 조치합니다.</p>
      <p>3. 대리인을 통한 권리 행사 시 위임장을 제출하여야 합니다.</p>
      <div style={noteStyle}>
        <strong>차량 소유자 등 제3자의 권리 행사:</strong> 해당 개인정보는 회사가 이용자로부터 위탁받아 처리하는 것이므로, 원칙적으로 <strong>해당 정보를 수집한 이용자(수출업체·대행업체 등)</strong>에게 요구하시면 됩니다. 회사로 직접 접수하신 경우에도 회사는 이를 <strong>지체 없이 해당 이용자에게 전달</strong>하고 처리 결과를 안내해 드립니다.
      </div>

      <h2 style={h2Style}>제11조 (개인정보의 안전성 확보 조치)</h2>
      {table(['구분', '조치 내용'], [
        ['암호화', '주민등록번호 등 고유식별정보 AES 암호화 저장, 비밀번호 단방향 해시(bcrypt) 저장, 전송 구간 HTTPS(TLS) 암호화'],
        ['접근 통제', '역할 기반 권한 관리(RBAC), 토큰 기반 인증, 업체 단위 데이터 격리, 최소 권한 원칙'],
        ['접속 기록', '서비스 이용·개인정보 열람 기록 보관 및 위·변조 방지'],
        ['화면 보호', '주민등록번호 등은 화면·목록·로그·API 응답에서 마스킹 표시'],
        ['재해 대비', '정기 백업 및 복구 절차 운영, 백업 데이터 접근 제한'],
        ['관리적 조치', '취급 직원 최소화 및 교육, 내부관리계획 수립·시행'],
      ])}

      <h2 style={h2Style}>제12조 (개인정보 보호책임자 및 열람 청구 접수 부서)</h2>
      <div style={boxStyle}>
        <p style={{ margin: '4px 0' }}><strong>개인정보 보호책임자</strong></p>
        <p style={{ margin: '4px 0' }}>성명 / 직책: ○○○</p>
        <p style={{ margin: '4px 0' }}>연락처: ○○○ · 이메일: support@autodex.kr</p>
        <p style={{ margin: '12px 0 4px' }}><strong>개인정보 열람·정정·삭제·처리정지 청구 접수</strong></p>
        <p style={{ margin: '4px 0' }}>이메일: support@autodex.kr (서비스 내 문의 기능 이용 가능)</p>
      </div>
      <p>정보주체는 개인정보 보호와 관련한 모든 문의·불만·피해구제를 위 연락처로 접수하실 수 있으며, 회사는 지체 없이 답변·처리합니다.</p>

      <h2 style={h2Style}>제13조 (권익침해 구제 방법)</h2>
      <p>개인정보 침해로 인한 피해 구제·상담이 필요한 경우 아래 기관에 문의하실 수 있습니다.</p>
      <ul style={ulStyle}>
        <li>개인정보분쟁조정위원회 — 1833-6972 (www.kopico.go.kr)</li>
        <li>개인정보침해신고센터 — 118 (privacy.kisa.or.kr)</li>
        <li>대검찰청 사이버수사과 — 1301 (www.spo.go.kr)</li>
        <li>경찰청 사이버수사국 — 182 (ecrm.police.go.kr)</li>
      </ul>

      <h2 style={h2Style}>제14조 (자동 수집 장치의 운영)</h2>
      <p>서비스는 로그인 상태 유지를 위해 인증 토큰을 이용자 기기의 브라우저 저장소(localStorage)에 저장합니다. 이는 서비스 이용에 필요한 최소한의 저장이며, <strong>광고·행태정보 수집을 위한 추적 쿠키는 사용하지 않습니다.</strong> 이용자는 브라우저 설정에서 저장된 정보를 삭제할 수 있으며, 이 경우 다시 로그인해야 합니다.</p>

      <h2 style={h2Style}>제15조 (만 14세 미만 아동)</h2>
      <p>서비스는 사업자를 대상으로 하는 업무용 서비스로, <strong>만 14세 미만 아동의 가입을 받지 않습니다.</strong></p>

      <h2 style={h2Style}>제16조 (개인정보처리방침의 변경)</h2>
      <p>이 방침의 내용 추가·삭제·수정이 있을 경우 시행 <strong>7일 전</strong>부터 서비스 공지사항을 통해 알립니다. 다만 정보주체 권리의 중요한 변경이 있는 경우에는 <strong>30일 전</strong>에 알립니다.</p>

      {footer()}
    </div>
  );
}

export { Terms, Privacy };
